import {
	Box,
	Link as ChakraLink,
	Icon,
	useBreakpointValue,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	useDisclosure,
	Image,
	Flex,
} from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { FaTwitter, FaTelegram, FaDiscord } from "react-icons/fa";
import { ChevronDownIcon } from "@chakra-ui/icons";
import CustomConnectButton from "./CustomConnectButton";
import fireGif from '../assets/images/gif/fire.gif';
import TokenPrice from "./TokenPrice";
import { useState } from "react";
import QRCodeModal from "./qrCode/QRCodeModal";
import { BiCoffeeTogo } from "react-icons/bi";

const isKeyMintAvailable = process.env.REACT_APP_MINT_AVAILIABLE === 'true';

const Navigation = () => {
	const fontSize = useBreakpointValue({ base: 'sm', md: 'md' });
	const spacing = useBreakpointValue({ base: 6, md: 6 });
	const location = useLocation();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	const getLinkStyle = (paths) => ({
		fontWeight: 'normal',
		textDecoration: 'none',
		color: paths.some(path => location.pathname.startsWith(path)) ? '#FF684B' : 'black',
	});

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexWrap="wrap"
			p={1}
			gap={spacing}
			position="relative"
		>
			<Link to="/check-marks-rank" style={getLinkStyle(['/check-marks-rank', '/check-badges-rank', '/check-custom-rank'])}>
				<Box fontSize={fontSize}>Check Rank</Box>
			</Link>

			{isKeyMintAvailable && (
				<Link
					to="/mint-key"
					_hover={{ color: '#FF684B', background: 'transparent' }}
				>
					<Flex flexFlow={"row"} alignItems={"center"} color={location.pathname === '/mint-key' ? '#FF684B' : 'black'}>
						Mint Key <Image src={fireGif} w="25px" pb="5px" />
					</Flex>
				</Link>
			)}

			<Box onMouseEnter={onOpen} onMouseLeave={onClose} position="relative">
				<Menu isOpen={isOpen}>
					<MenuButton
						as={Box}
						minH={'35px'}
						cursor="pointer"
						background="transparent"
						border="none"
						fontSize={fontSize}
						display="flex"
						alignItems="center"
					>
						More <ChevronDownIcon transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"} transition="transform 0.2s" />
					</MenuButton>

					<MenuList mt="-5px">
						<MenuItem
							mt="-5px"
							as={ChakraLink}
							href="https://game.scrollstat.xyz/"
							isExternal
							_hover={{ color: '#FF684B', background: 'transparent' }}
							_focus={{ color: '#FF684B', background: 'transparent' }}
							style={{ textDecoration: 'none' }}
						>
							Play Game
						</MenuItem>
						<MenuItem
							as={Link}
							to="/scroll-canvas-badges"
							_hover={{ color: '#FF684B', background: 'transparent' }}
						>
							Scroll Canvas
						</MenuItem>
						<MenuItem
							as={Link}
							to="/scroll-marks-calculator"
							_hover={{ color: '#FF684B', background: 'transparent' }}
						>
							Marks Calculator
						</MenuItem>
						<MenuItem
							as={Link}
							to="/partnership"
							_hover={{ color: '#FF684B', background: 'transparent' }}
						>
							Partnership
						</MenuItem>
						<MenuItem
							as={Link}
							to="/top100"
							_hover={{ color: '#FF684B', background: 'transparent' }}
						>
							Top 100
						</MenuItem>
						<MenuItem
							as={Link}
							to="/faq"
							_hover={{ color: '#FF684B', background: 'transparent' }}
						>
							Faq
						</MenuItem>
						<MenuItem
							as={Link}
							to="/contact"
							_hover={{ color: '#FF684B', background: 'transparent' }}
						>
							Contact
						</MenuItem>
					</MenuList>
				</Menu>
			</Box>
			<TokenPrice />
			<ChakraLink
				href="https://x.com/scrollstat"
				isExternal
				style={{
					textDecoration: 'none',
					color: 'black',
					display: 'flex',
					alignItems: 'center',
				}}
				_hover={{ color: '#FF684B', background: 'transparent' }}
			>
				<Icon as={FaTwitter} boxSize={5} />
			</ChakraLink>
			<ChakraLink
				href="https://t.me/scrollstat"
				isExternal
				style={{
					textDecoration: 'none',
					color: 'black',
					display: 'flex',
					alignItems: 'center',
				}}
				_hover={{ color: '#FF684B', background: 'transparent' }}
			>
				<Icon as={FaTelegram} boxSize={5} />
			</ChakraLink>
			<ChakraLink
				href="https://discord.gg/vDu6ay7v"
				isExternal
				style={{
					textDecoration: 'none',
					color: 'black',
					display: 'flex',
					alignItems: 'center',
				}}
				_hover={{ color: '#FF684B', background: 'transparent' }}
			>
				<Icon as={FaDiscord} boxSize={5} />
			</ChakraLink>

			<Flex justifyContent={"center"} onClick={openModal} cursor="pointer">
				<Icon as={BiCoffeeTogo} boxSize={5} />
			</Flex>

			<CustomConnectButton />

			<QRCodeModal
				isOpen={isModalOpen}
				onClose={closeModal}
				walletAddress="0x2207ab8d4cf5b6c69bcef3a1b365d8da95247e88"
			/>
		</Box>
	);
};

export default Navigation;
